import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { customerUser } from 'global/Models/userModel';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import ApiService from 'global/utils/ApiService';
import { setCustomerUser } from 'redux/reducer/user/userReducer';
import { AppDispatch } from 'redux/store';

export const getCustomerUser = (userId: number) => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.customerUserSearch, { userId })
    .then((res: IBackendSearchGeneric<customerUser>) =>
      handleApiThenGeneric<IBackendSearchGeneric<customerUser>, customerUser[]>({
        res,
        onSuccessData: (data) => dispatch(setCustomerUser(data[0])),
        notifFail: false,
        notifSuccess: false,
      })
    )
    .catch(() => {});
};
